import { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleMagicLink = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: window.location.origin },
    })
    setLoading(false)
    if (error) setError(error.message)
    else setSent(true)
  }

  const handleGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: window.location.origin },
    })
  }

  return (
    <div className="flex min-h-svh items-center justify-center bg-zinc-50">
      <div className="w-full max-w-[400px] rounded-2xl bg-white p-12 shadow-[0_1px_3px_rgba(0,0,0,0.04),0_8px_32px_rgba(0,0,0,0.06)]">
        <div className="mb-10 text-center">
          <h1 className="font-[Inter_Tight] text-[32px] font-bold tracking-tight text-zinc-900">
            /slash
          </h1>
          <p className="mt-2 text-sm text-zinc-400">LinkedIn messaging, reimagined</p>
        </div>

        {sent ? (
          <div className="rounded-xl bg-blue-50 p-4 text-center text-sm text-blue-700">
            Check your email for a magic link to sign in.
          </div>
        ) : (
          <>
            <form onSubmit={handleMagicLink} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-[13px] font-medium text-zinc-600">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  className="mt-1.5 block w-full rounded-[10px] border border-zinc-200 bg-zinc-50 px-3.5 py-[11px] text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>

              {error && <p className="text-sm text-red-600">{error}</p>}

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-[10px] bg-zinc-900 px-5 py-3 text-sm font-medium text-white hover:bg-zinc-800 disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send magic link'}
              </button>
            </form>

            <div className="my-6 flex items-center gap-4">
              <div className="h-px flex-1 bg-zinc-200" />
              <span className="text-xs text-zinc-400">or</span>
              <div className="h-px flex-1 bg-zinc-200" />
            </div>

            <button
              onClick={handleGoogle}
              className="flex w-full items-center justify-center gap-2 rounded-[10px] border border-zinc-200 px-5 py-[11px] text-sm font-medium text-zinc-600 hover:bg-zinc-50"
            >
              Continue with Google
            </button>
          </>
        )}
      </div>
    </div>
  )
}
